module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-stone-path-remnants.1d41f1b4.png";